import type { RouteObject } from 'react-router';

import { AuthLayout } from '@/features/auth/auth-layout';

import { SharePage } from './share-page';

/** A "post from phone" link, in the auth screens' shell and behind no guard. */
export const shareRoute: RouteObject = {
  element: <AuthLayout />,
  children: [{ path: 'share/:token', element: <SharePage /> }],
};
